module.exports = __webpack_public_path__ + "static/media/contenedores-04.9031c84e.png";